/**
 * Seleciona um item aleatório com base nos pesos relativos.
 * Itens com weight maior têm proporcionalmente mais chance de serem selecionados.
 */
export function weightedRandom<T extends { weight: number }>(items: T[]): T {
  if (items.length === 0) throw new Error('weightedRandom: empty array')
  if (items.length === 1) return items[0]

  const total = items.reduce((sum, item) => sum + item.weight, 0)
  let rand = Math.random() * total

  for (const item of items) {
    rand -= item.weight
    if (rand <= 0) return item
  }

  return items[items.length - 1]
}
